import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import FormAstronaut from '../../components/Forms/FormAstronaut/FormAstronaut'
import FormLogin from '../../components/Forms/FormLogin/FormLogin'
import Typography from '../../components/Typography/Typography'

import hocConnect from './hocLogin'

import { push } from '@lagunovsky/redux-react-router'
import './Login.scss'

const Login = ({
    isAuth,
    loading,
    error,
    login,
    loginUsingApple,
    loginUsingFacebook,
    loginUsingGoogle,
    loginSocialsError,
}) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    if (isAuth) dispatch(push('/user-profile'))

    return (
        <Container fluid className={'d-flex flex-column'}>
            <div className={'login-page d-flex flex-column'}>
                <Typography variant={'h2'}>{intl.formatMessage({ id: 'forms.login.title' })}</Typography>

                <div className={'login-page--content d-flex'}>
                    <FormAstronaut />

                    <FormLogin
                        handleSubmit={login}
                        handleGoogle={loginUsingGoogle}
                        handleFacebook={loginUsingFacebook}
                        handleApple={loginUsingApple}
                        handleSocialsError={loginSocialsError}
                        formErrors={error}
                        loading={loading}
                    />
                </div>
            </div>
        </Container>
    )
}

export default hocConnect(Login)
